export default __webpack_public_path__ + "static/media/ChatWithFacility.e52bed5c.svg";